export function animateTextBlock() {
    const LETTER_INTERVAL = 10; // ms delay between letters
    const INDEX_DIVIDER = 2;
    const headings = document.querySelectorAll(".pul-text-block h3");

    if (!headings.length) return;

    headings.forEach(textBlock => {
        const lettersHTML = textBlock.textContent
            .split("")
            .map(letter => `<span class="animating">${letter}</span>`)
            .join("");

        textBlock.innerHTML = lettersHTML;
        const animatedLetters = textBlock.querySelectorAll(".animating");

        const observer = new IntersectionObserver(([entry], obs) => {
            if (entry.isIntersecting) {
                animatedLetters.forEach((el, i) => {
                    setTimeout(() => el.classList.add("in-view"), (i / INDEX_DIVIDER) * LETTER_INTERVAL);
                });

                obs.unobserve(entry.target); // animate once
            }
        }, {
            threshold: 0.2,
            rootMargin: '0px 0px -5% 0px'
        });

        observer.observe(textBlock);
    });
}